import { render, staticRenderFns } from "./AttendanceStatQuery.vue?vue&type=template&id=6b23674c&"
import script from "./AttendanceStatQuery.vue?vue&type=script&lang=js&"
export * from "./AttendanceStatQuery.vue?vue&type=script&lang=js&"
import style0 from "./AttendanceStatQuery.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports